import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import Modal from '../Modal';

export const Text = styled.h2`
  ${fontSize(14)};
  text-align: center;
  font-weight: 500;
`;
export const StyledModal = styled(Modal)`
  padding: 60px 30px;
  > div {
    margin: 0;
  }
`;
export const IconContainer = styled.div`
  display: flex;
  justify-content: center;

  i {
    ${fontSize(70)};
    color: ${({ theme }) => theme.primaryColor};
    cursor: default;
  }
`;
